import { createRouter, createWebHistory } from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import Terms from "../views/Terms.vue";
import Policy from "../views/Policy.vue";
import UserTable from "../views/admin/users/Tables.vue";
import UserCreate from "../views/admin/users/Create.vue";
import ModelsTable from "../views/admin/models/Tables.vue";
import ModelsCreate from "../views/admin/models/Create.vue";
import MachineryTable from "../views/admin/machinery/Tables.vue";
import Map from "../views/admin/map/Map.vue";
import MapDesigner from "../views/admin/map/MapDesigner.vue";
import InventoryTable from "../views/admin/inventory/Tables.vue";
import PaymentTable from "../views/admin/payments/Tables.vue";
import ProductionTable from "../views/admin/production/Tables.vue";
import ProductionCreate from "../views/admin/production/Create.vue";
import OvenTable from "../views/admin/oven/Tables.vue";
import OvenCreate from "../views/admin/oven/Create.vue";
import ProductionUserTable from "../views/admin/production-user/Tables.vue";
import OperatorDashboard from "../views/operator/dashboard/Index.vue";
import OperatorProductionUserTable from "../views/operator/production-user/Tables.vue";
import MinesExtractionsTables from "../views/admin/mines-extractions/Tables.vue";
import MinesExtractionsCreate from "../views/admin/mines-extractions/Create.vue";
import minesExtractionsTransport from "../views/admin/mines-extractions/Transport.vue";
import minesExtractionsFinal from "../views/admin/mines-extractions/Final.vue";
import ReportTable from "../views/admin/reports/Tables.vue";
import SettingsIndex from "../views/admin/settings/Index.vue";
import SuppliesTable from "../views/admin/supplies/Tables.vue";
import SuppliesCreate from "../views/admin/supplies/Create.vue";
import PurchasesTable from "../views/admin/purchases/Tables.vue";
import PurchasesCreate from "../views/admin/purchases/Create.vue";
import NominaTable from "../views/admin/nomina/Tables.vue";
import NominaPaymentsTable from "../views/admin/nomina/Payments.vue";
import NominaProductionsTable from "../views/admin/nomina/Production.vue";
import Login from "../views/auth/Login.vue";
import Register from "../views/auth/Register.vue";
import RemissionsTable from "../views/admin/remissions/Table.vue";
import RemissionsCreate from "../views/admin/remissions/Create.vue";
import TransfersTable from "../views/admin/transfers/Table.vue";
import TransfersCreate from "../views/admin/transfers/Create.vue";
import UserProfile from "../views/examplesApi/UserProfile/EditUserProfile.vue";
import ForgotPassword from "../views/auth/ForgotPassword.vue";
import ResetPassword from "../views/auth/ResetPassword.vue";
import auth from "../middleware/auth";
import guest from "../middleware/guest";
import success from "../views/success.vue";
import fail from "../views/fail.vue";
import SistemaFotovoltaico from "../views/SistemaFotovoltaico.vue";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/dashboard-default",
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      middleware: guest,
    },
  },
  {
    path: "/dashboard-default",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      middleware: auth,
      routeName: "Inicio",
    },
  },
  {
    path: "/operator",
    name: "OperatorDashboard",
    routeName: "Operador - Inicio",
    component: OperatorDashboard,
    meta: {
      middleware: auth,
      routeName: "Operador - Inicio",
    },
  },
  {
    path: "/operator/production-user",
    name: "OperatorProductionUser",
    routeName: "Operador - Mis tareas",
    component: OperatorProductionUserTable,
    meta: {
      middleware: auth,
      routeName: "Operador - Mis tareas",
    },
  },
  {
    path: "/users",
    name: "Users",
    routeName: "Usuarios",
    component: UserTable,
    meta: {
      middleware: auth,
      routeName: "Empleados",
    },
  },
  {
    path: "/users/create",
    name: "User Create",
    routeName: "Crear Usuarios",
    component: UserCreate,
    meta: {
      middleware: auth,
      routeName: "Crear Empleado",
    },
  },
  {
    path: "/machinery",
    name: "Machinery",
    routeName: "Maquinaria",
    component: MachineryTable,
    meta: {
      middleware: auth,
      routeName: "Maquinaria",
    },
  },
  {
    path: "/map",
    name: "Map",
    routeName: "Mapa",
    component: Map,
    meta: {
      middleware: auth,
      routeName: "Mapa",
    },
  },
  {
    path: "/map/designer",
    name: "MapDesigner",
    routeName: "Mapa dinámico",
    component: MapDesigner,
    meta: {
      middleware: auth,
      routeName: "Mapa dinámico",
    },
  },
  {
    path: "/models",
    name: "Models",
    routeName: "Modelos",
    component: ModelsTable,
    meta: {
      middleware: auth,
      routeName: "Referencias",
    },
  },
  {
    path: "/models/create",
    name: "Models Create",
    routeName: "Crear Modelo",
    component: ModelsCreate,
    meta: {
      middleware: auth,
      routeName: "Crear Referencia",
    },
  },
  {
    path: "/inventory",
    name: "Inventory",
    routeName: "Inventario",
    component: InventoryTable,
    meta: {
      middleware: auth,
      routeName: "Inventario",
    },
  },
  {
    path: "/nomina",
    name: "Nomina",
    routeName: "Nomina",
    component: NominaTable,
    meta: {
      middleware: auth,
      routeName: "Nomina",
    },
  },
  {
    path: "/nomina-payments",
    name: "Nomina Payments",
    routeName: "Nomina-payments",
    component: NominaPaymentsTable,
    props: true,
    meta: {
      middleware: auth,
      routeName: "Pagos Nomina",
    },
  },
  {
    path: "/nomina-productions",
    name: "Nomina Productions",
    routeName: "Trabajos realizados",
    component: NominaProductionsTable,
    props: true,
    meta: {
      middleware: auth,
      routeName: "Trabajos realizados",
    },
  },
  {
    path: "/production",
    name: "Production",
    routeName: "Producción",
    component: ProductionTable,
    meta: {
      middleware: auth,
      routeName: "Producción",
    },
  },
  {
    path: "/production/create",
    name: "Production Create",
    routeName: "Crear Producción",
    component: ProductionCreate,
    meta: {
      middleware: auth,
      routeName: "Crear Producción",
    },
  },
  {
    path: "/transfers",
    name: "Transfers",
    routeName: "Traslados",
    component: TransfersTable,
    meta: {
      middleware: auth,
      routeName: "Traslados",
    },
  },
  {
    path: "/transfers/create",
    name: "Transfers Create",
    routeName: "Crear Traslado",
    component: TransfersCreate,
    meta: {
      middleware: auth,
      routeName: "Crear Traslado",
    },
  },
  {
    path: "/oven",
    name: "Horno",
    routeName: "Oven",
    component: OvenTable,
    meta: {
      middleware: auth,
      routeName: "Horno",
    },
  },
  {
    path: "/oven/create",
    name: "Oven Create",
    routeName: "Detalles del horno",
    component: OvenCreate,
    meta: {
      middleware: auth,
      routeName: "Detalles del horno",
    },
  },
  {
    path: "/mines-extractions",
    name: "Extraction",
    routeName: "Minas",
    component: MinesExtractionsTables,
    meta: {
      middleware: auth,
      routeName: "Plan de Extracción",
    },
  },
  {
    path: "/mines-extractions/create",
    name: "Extraction Create",
    routeName: "Minas",
    component: MinesExtractionsCreate,
    meta: {
      middleware: auth,
      routeName: "Crear Plan de Extracción",
    },
  },
  {
    path: "/mines-extractions/transport",
    name: "Extraction Transport",
    routeName: "Minas",
    component: minesExtractionsTransport,
    meta: {
      middleware: auth,
      routeName: "Transporte",
    },
  },
  {
    path: "/mines-extractions/final",
    name: "Extraction Final",
    routeName: "Minas",
    component: minesExtractionsFinal,
    meta: {
      middleware: auth,
      routeName: "Transporte",
    },
  },
  {
    path: "/production-user",
    name: "Production User",
    routeName: "Producción",
    component: ProductionUserTable,
    meta: {
      middleware: auth,
      routeName: "Producción",
    },
  },
  {
    path: "/supplies",
    name: "Supplies",
    routeName: "Insumos",
    component: SuppliesTable,
    meta: {
      middleware: auth,
      routeName: "Insumos",
    },
  },
  {
    path: "/supplies/create",
    name: "Supplies Create",
    routeName: "Crear Insumo",
    component: SuppliesCreate,
    meta: {
      middleware: auth,
      routeName: "Crear Insumos",
    },
  },
  {
    path: "/purchases",
    name: "Purchases",
    routeName: "Compras",
    component: PurchasesTable,
    meta: {
      middleware: auth,
      routeName: "Compras",
    },
  },
  {
    path: "/reports",
    name: "Reports",
    routeName: "Reportes",
    component: ReportTable,
    meta: {
      middleware: auth,
      routeName: "Reportes",
    },
  },
  {
    path: "/settings",
    name: "Settings",
    routeName: "Configuración",
    component: SettingsIndex,
    meta: {
      middleware: auth,
      routeName: "Configuración",
    },
  },
  {
    path: "/purchases/create",
    name: "Purchases Create",
    routeName: "Crear Compra",
    component: PurchasesCreate,
    meta: {
      middleware: auth,
      routeName: "Crear Compras",
    },
  },
  {
    path: "/user-profile",
    name: "User Profile",
    routeName: "Perfil",
    component: UserProfile,
    meta: {
      middleware: auth,
      routeName: "Perfil",
    },
  },
  {
    path: "/register",
    name: "Register",
    routeName: "Registro",
    component: Register,
    meta: {
      middleware: guest,
    },
  },
  {
    path: "/remissions",
    name: "Remissions",
    routeName: "Remisiones",
    component: RemissionsTable,
    meta: {
      middleware: auth,
      routeName: "Pedidos",
    },
  },
  {
    path: "/remissions/create",
    name: "Remissions Create",
    routeName: "Crear Pedido",
    component: RemissionsCreate,
    meta: {
      middleware: auth,
      routeName: "Crear Pedido",
    },
  },
  {
    path: "/password/forgot",
    name: "Forgot Password",
    routeName: "Olvido clave",
    component: ForgotPassword,
    meta: {
      middleware: guest,
    },
  },
  {
    path: "/password/reset",
    name: "Reset Password",
    routeName: "Cambiar clave",
    component: ResetPassword,
    meta: {
      middleware: guest,
    },
  },
  {
    path: "/payment",
    name: "Payment",
    routeName: "Payment",
    component: PaymentTable,
    meta: {
      middleware: auth,
      routeName: "Pagos",
    },
  },
  {
    path: "/sistema-fotovoltaico",
    name: "Sistema Fotovoltaico",
    routeName: "Sistema fotovoltaico",
    component: SistemaFotovoltaico,
  },
  {
    path: "/terms",
    name: "Terms",
    routeName: "Terminos",
    component: Terms,
  },
  {
    path: "/policy",
    name: "Policy",
    routeName: "Politicas",
    component: Policy,
  },
  {
    path: "/success",
    name: "Success",
    routeName: "Exito",
    component: success,
  },
  {
    path: "/fail",
    name: "Fail",
    routeName: "Fallo",
    component: fail,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

// Creates a nextMiddleware() function which not only
// runs the default next() callback but also triggers
// the subsequent Middleware function.
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  // If no subsequent Middleware exists,
  // the default next() callback is returned.
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    // Run the default Vue Router next() callback first.
    context.next(...parameters);
    // Then run the subsequent Middleware with a new
    // nextMiddleware() callback.
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

router.beforeEach((to, from, next) => {
  // Operadores (rol 3): redirigir a su vista de tareas para poder recibir/entregar
  if (to.path === '/production-user') {
    try {
      const user = JSON.parse(localStorage.getItem('user'));
      if (user && String(user.role) === '3') {
        return next({ path: '/operator/production-user', replace: true });
      }
    } catch {
      // Si no hay usuario o localStorage falla, seguir con la ruta normal
    }
  }

  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];
    const context = { from, next, to, router };
    const nextMiddleware = nextFactory(context, middleware, 1);

    return middleware[0]({ ...context, next: nextMiddleware });
  }

  return next();
});

export default router;
